/*
Configuration
*/
var axios = require('axios')

var API_URL = '/api'
var TIMEOUT = 600000
var HEADERS = {
  'Content-Type': 'application/json'
}

var Api = axios.create({
  baseURL: API_URL,
  timeout: TIMEOUT,
  headers: HEADERS
})

Api.CancelToken = axios.CancelToken
Api.isCancel = axios.isCancel

module.exports = Api
